function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { attendanceStatistics, individualStatistics } from '@/api/user';
export default {
  name: '',
  components: {
    echartBox: function echartBox() {
      return import('@/components/common/echarts');
    },
    oaFromBox: function oaFromBox() {
      return import('@/components/common/oaFromBox');
    }
  },
  data: function data() {
    return {
      work_hours: 0,
      // 平均工时
      required_days: 0,
      // 应出勤天数
      absenteeism: 0,
      // 未出勤
      normal_days: 0,
      // 实际出勤
      userList: [],
      search: [{
        field_name: '开始时间',
        field_name_end: '结束时间',
        field_name_en: 'time',
        form_value: 'date_picker'
      }, {
        field_name: '请选择人员',
        field_name_en: 'user_id',
        form_value: 'user_id',
        data_dict: []
      }],
      totalPage: 0,
      options: [{
        id: 1,
        name: '正常'
      }, {
        id: 2,
        name: '迟到'
      }, {
        id: 3,
        name: '严重迟到'
      }, {
        id: 4,
        name: '早退'
      }, {
        id: 5,
        name: '缺卡'
      }, {
        id: 6,
        name: '地点异常'
      }],
      clockInList: [{
        num: 0,
        img: require('../../../assets/images/clock1.png'),
        title: '迟到(次)'
      }, {
        num: 0,
        img: require('../../../assets/images/clock2.png'),
        title: '早退(次)'
      }, {
        num: 0,
        img: require('../../../assets/images/clock3.png'),
        title: '缺卡(次)'
      }, {
        num: 0,
        img: require('../../../assets/images/clock5.png'),
        title: '地点异常(次)'
      }, {
        num: 0,
        img: require('../../../assets/images/clock4.png'),
        title: '旷工(天)'
      }],
      attendanceList: [{
        num: 0,
        img: require('../../../assets/images/single1.png'),
        title: '请假(小时)'
      }, {
        num: 0,
        img: require('../../../assets/images/single2.png'),
        title: '出差(天)'
      }, {
        num: 0,
        img: require('../../../assets/images/single3.png'),
        title: '外出(小时)'
      }, {
        num: 0,
        img: require('../../../assets/images/single4.png'),
        title: '加班(小时)'
      }, {
        num: 0,
        img: require('../../../assets/images/single5.png'),
        title: '补卡(次)'
      }],
      where: {
        time: this.$moment().startOf('months').format('YYYY/MM/DD') + '-' + this.$moment(new Date()).format('YYYY/MM/DD'),
        user_id: '',
        status: '',
        page: 1,
        limit: 15
      },
      defaultUse: {},
      tableData: [],
      optionData: {},
      styles: {
        height: '256px',
        width: '256px',
        margin: 'auto'
      }
    };
  },
  mounted: function mounted() {
    var userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.defaultUse = {
      label: userInfo.name,
      value: userInfo.id,
      name: userInfo.name,
      id: userInfo.id
    };
    this.userList.push(this.defaultUse);
    this.where.user_id = userInfo.value;
    this.getOptionData();
    this.getList();
    this.getDataList();
  },
  methods: {
    confirmData: function confirmData(data) {
      if (data == 'reset') {
        this.where.user_id = [];
        this.where.status = '';
        this.where.time = this.$moment().startOf('months').format('YYYY/MM/DD') + '-' + this.$moment(new Date()).format('YYYY/MM/DD');
      } else {
        for (var i in data) {
          this.where[i] = data[i];
        }
      }
      this.getDataList();
      this.getList();
    },
    getSelectList: function getSelectList(data) {
      this.userList = data;
      this.where.user_id = data[0].value;
      this.timeChange();
    },
    timeChange: function timeChange() {
      this.getDataList();
      this.getList();
    },
    getDataList: function getDataList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              data = {
                time: _this.where.time,
                user_id: _this.where.user_id,
                status: _this.where.status,
                page: _this.where.page,
                limit: _this.where.limit
              };
              _context.next = 3;
              return individualStatistics(data);
            case 3:
              result = _context.sent;
              _this.tableData = result.data.list;
              _this.totalPage = result.data.count;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.where.page = 1;
      this.where.limit = val;
      this.getDataList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.where.page = page;
      this.getDataList();
    },
    getList: function getList() {
      var _this2 = this;
      var data = {
        time: this.where.time,
        user_id: this.where.user_id
      };
      attendanceStatistics(data).then(function (res) {
        _this2.work_hours = res.data.work_hours;
        _this2.absenteeism = res.data.absenteeism;
        _this2.required_days = res.data.required_days;
        _this2.normal_days = res.data.normal_days;
        _this2.attendanceList[0].num = res.data.leave_hours;
        _this2.attendanceList[1].num = res.data.trip_hours;
        _this2.attendanceList[2].num = res.data.out_hours;
        _this2.attendanceList[3].num = res.data.overtime_hours;
        _this2.attendanceList[4].num = res.data.sign;
        _this2.clockInList[0].num = res.data.late;
        _this2.clockInList[1].num = res.data.early_leave;
        _this2.clockInList[2].num = res.data.lack_card;
        _this2.clockInList[3].num = res.data.location_abnormal;
        _this2.clockInList[4].num = res.data.absenteeism;
        _this2.getOptionData();
      });
    },
    // 处理表格班次数据
    getShift: function getShift(data) {
      var text2 = '';
      var text1 = '';
      if (data.rules && data.rules.length !== 0) {
        text1 = "".concat(data.rules[0].first_day_after == 0 ? '当日' : '次日').concat(data.rules[0].work_hours, " - ").concat(data.rules[0].second_day_after == 0 ? '当日' : '次日').concat(data.rules[0].off_hours);
        if (data.rules[1]) {
          text2 = "".concat(data.rules[1].first_day_after == 0 ? '当日' : '次日').concat(data.rules[1].work_hours, " - ").concat(data.rules[1].second_day_after == 0 ? '当日' : '次日').concat(data.rules[1].off_hours);
        }
      }
      return text1 + text2;
    },
    // 处理表格打卡结果数据
    getStatus: function getStatus(status, tip) {
      var str = '';
      var tips = '';
      if (status == 0 || status == 1) {
        str = '正常';
      } else if (status == 2) {
        str = '迟到';
      } else if (status == 3) {
        str = '严重迟到';
      } else if (status == 4) {
        str = '早退';
      } else {
        str = '缺卡';
      }
      if (tip == 0) {} else if (tip == 1) {
        tips = '(外勤卡)';
      } else if (tip == 2) {
        tips = '(地点异常)';
      }
      return str + tips;
    },
    getOptionData: function getOptionData() {
      var absenteeism = this.absenteeism ? this.absenteeism : 0; // 未出勤
      var normal_days = this.normal_days ? this.normal_days : 0; // 实际出勤

      var days = this.required_days ? this.required_days : 0;
      var dataArr = [{
        value: normal_days,
        name: '实际出勤(天)'
      }, {
        value: absenteeism,
        name: '未出勤(天)'
      }];
      this.optionData = {
        color: ['#1890FF', '#FF9900'],
        tooltip: {
          trigger: 'item'
        },
        legend: {
          bottom: '1%',
          left: 'center',
          icon: 'circle',
          itemWidth: 10,
          textStyle: {
            fontSize: 13,
            color: '#606266',
            lineHeight: 20 // 解决提示语字显示不全
          },
          formatter: function formatter(name) {
            var count;
            for (var i = 0; i < dataArr.length; i++) {
              if (dataArr[i].name === name) {
                count = dataArr[i].value;
              }
            }
            var arr = [name + '  ' + count];
            return arr.join('\n');
          }
        },
        series: [{
          type: 'pie',
          radius: ['45%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: 'center',
            formatter: [days, '{name|应出勤天数}'].join('\n'),
            color: '#333',
            textStyle: {
              fontSize: 18,
              fill: '#333',
              lineHeight: 26,
              rich: {
                name: {
                  fontSize: 14,
                  fill: '#333',
                  color: '#3D3D3D'
                }
              }
            }
          },
          labelLine: {
            show: false
          },
          data: dataArr
        }]
      };
    },
    reset: function reset() {
      this.where.time = [this.$moment().startOf('months').format('YYYY/MM/DD'), this.$moment(new Date()).format('YYYY/MM/DD')];
      this.userList = [];
      this.where.user_id = '';
      this.getDataList();
      this.getList();
    }
  }
};